import { AUTH_BYPASS } from "@/auth/MsalConfig";

export function AuthBypassBanner() {
  if (!AUTH_BYPASS) {
    return null;
  }
  return (
    <div
      data-testid="auth-bypass-banner"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 100000,
        background: "var(--destructive)",
        color: "var(--primary-foreground)",
        textAlign: "center",
        padding: "4px 8px",
        fontWeight: 700,
        fontSize: 12,
        letterSpacing: 1,
      }}
    >
      AUTH BYPASS ACTIVE — NOT FOR PRODUCTION
    </div>
  );
}
